// src/App.js
import React, { useRef } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import HeroSection from "./components/HeroSection/HeroSection";
import TestimonialsSection from "./components/TestimonialsSection/TestimonialsSection";
import ProjectsSection from "./components/ProjectSection/ProjectsSection";
import FounderSection from "./components/FounderSection/FounderSection";
import DesignDetailsSection from "./components/DesignDetailsSection/DesignDetailsSection";
import FooterSection from "./components/FooterSection/FooterSection";
import ProcessSection from "./components/ProcessSection/ProcessSection";
import ComingSoonPage from "./pages/ComingSoonPage";
import ProjectsPage from "./pages/ProjectsPage/ProjectsPage"; // 🆕 Import
import usePageTracking from "./usePageTracking";

function MainLandingPage() {
	const contactRef = useRef(null);

	const scrollToSection = () => {
		if (contactRef.current) {
			window.scrollTo({
				top: contactRef.current.offsetTop,
				behavior: "smooth",
			});
		}
	};

	return (
		<>
			<HeroSection scrollToSection={scrollToSection} />
			<ProjectsSection />
			<ProcessSection />
			<FounderSection />
			<DesignDetailsSection />
			<TestimonialsSection />
			<FooterSection ref={contactRef} />
		</>
	);
}

// 🔍 This runs the tracking hook inside the Router context
function RouteChangeTracker() {
	usePageTracking();
	return null;
}

function App() {
	return (
		<Router>
			{/*<Routes>
				<Route path="/" element={<MainLandingPage />} />
				<Route path="/projects" element={<ProjectsPage />} /> 🆕 Route
				{/* <Route path="/coming-soon" element={<ComingSoonPage />} /> 
			</Routes>*/}
<RouteChangeTracker /> {/* Tracks every route change */}
			<Routes>
				<Route path="/" element={<MainLandingPage />} />
				<Route path="/projects" element={<ProjectsPage />} />
				{/* <Route path="/coming-soon" element={<ComingSoonPage />} /> */}
			</Routes>

		</Router>
	);
}

export default App;